enum ClaimCommentType {
  undefined = 0,
  internal = 1,
  external = 2,
}
export default ClaimCommentType;
